"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getLocalTheme;
exports.getLocalThemePrimaryColor = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _Button = _interopRequireDefault(require("@vfuk/core-button/dist/themes/Button.theme"));
var _LinkWithIcon = _interopRequireDefault(require("@vfuk/core-link-with-icon/dist/themes/LinkWithIcon.theme"));
var _Span = _interopRequireDefault(require("@vfuk/core-span/dist/themes/Span.theme"));
var _RangeSlider = _interopRequireDefault(require("@vfuk/core-range-slider/dist/themes/RangeSlider.theme"));
var _Heading = _interopRequireDefault(require("@vfuk/core-heading/dist/themes/Heading.theme"));
var _Paragraph = _interopRequireDefault(require("@vfuk/core-paragraph/dist/themes/Paragraph.theme"));
var _config = _interopRequireDefault(require("../../config/config"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const defaultButtonTheme = (0, _Button.default)(_r10SourceLibrary.themeWS10);
const defaultLinkTheme = (0, _LinkWithIcon.default)(_r10SourceLibrary.themeWS10);
const defaultRangeSliderTheme = (0, _RangeSlider.default)(_r10SourceLibrary.themeWS10);
const defaultSpanTheme = (0, _Span.default)(_r10SourceLibrary.themeWS10);
const defaultHeadingTheme = (0, _Heading.default)(_r10SourceLibrary.themeWS10);
const defaultParagraphTheme = (0, _Paragraph.default)(_r10SourceLibrary.themeWS10);
const blueButtonTheme = {
  ...defaultButtonTheme,
  appearance: {
    ...defaultButtonTheme.appearance,
    primary: {
      ...defaultButtonTheme.appearance.primary,
      color: '#fff',
      borderColor: '#002EFF',
      backgroundColor: '#002EFF',
      hover: {
        ...defaultButtonTheme.appearance.primary.hover,
        backgroundColor: '#fff',
        borderColor: '#002EFF',
        color: '#002EFF',
        boxShadow: '0 0 0 3px #002EFF;'
      },
      pressed: {
        ...defaultButtonTheme.appearance.primary.hover,
        backgroundColor: '#fff',
        borderColor: '#002EFF',
        color: '#002EFF',
        boxShadow: '0 0 0 3px #002EFF;'
      }
    },
    alt1: {
      ...defaultButtonTheme.appearance.alt1,
      borderColor: '#002EFF',
      color: '#002EFF',
      hover: {
        ...defaultButtonTheme.appearance.alt1.hover,
        backgroundColor: '#F7F7F7',
        borderColor: '#66686C',
        color: '#66686C',
        boxShadow: '0 0 3px #66686C'
      },
      pressed: {
        ...defaultButtonTheme.appearance.alt1.pressed,
        backgroundColor: '#F7F7F7',
        borderColor: '#66686C',
        color: '#66686C',
        boxShadow: '0 0 3px #66686C'
      }
    },
    alt2: {
      ...defaultButtonTheme.appearance.alt2,
      color: '#002EFF',
      borderColor: '#002EFF',
      backgroundColor: '#fff',
      hover: {
        ...defaultButtonTheme.appearance.alt2.hover,
        backgroundColor: '#002EFF',
        borderColor: '#002EFF',
        color: '#fff'
      }
    }
  },
  borderRadius: '100px',
  borderWidth: '2px'
};
const linkWithIconTheme = {
  ...defaultLinkTheme,
  appearance: {
    ...defaultButtonTheme.appearance,
    secondary: {
      ...defaultLinkTheme.appearance.secondary,
      color: '#002EFF',
      hoverColor: '#002EFF'
    },
    primary: {
      ...defaultLinkTheme.appearance.primary,
      color: '#002EFF',
      hoverColor: '#002EFF'
    },
    alt1: {
      ...defaultLinkTheme.appearance.alt1,
      color: '#002EFF',
      hoverColor: '#002EFF'
    }
  }
};
const RangeSliderTheme = {
  ...defaultRangeSliderTheme,
  appearance: {
    ...defaultRangeSliderTheme.appearance,
    primary: {
      ...defaultRangeSliderTheme.appearance.primary,
      backgroundColor: {
        ...defaultRangeSliderTheme.appearance.primary.backgroundColor,
        default: '#002EFF',
        hover: '#002EFF',
        pressed: '#002EFF'
      }
    },
    secondary: {
      ...defaultRangeSliderTheme.appearance.secondary,
      backgroundColor: {
        ...defaultRangeSliderTheme.appearance.secondary.backgroundColor,
        default: '#002EFF',
        hover: '#002EFF',
        pressed: '#002EFF'
      }
    }
  }
};
const SpanTheme = {
  ...defaultSpanTheme,
  appearance: {
    ...defaultSpanTheme.appearance,
    primary: {
      ...defaultSpanTheme.appearance.primary,
      color: '#002EFF'
    }
  }
};
const HeadingTheme = {
  ...defaultHeadingTheme,
  appearance: {
    ...defaultHeadingTheme.appearance,
    secondary: {
      ...defaultHeadingTheme.appearance.secondary,
      color: '#002EFF'
    }
  }
};
const ParagraphTheme = {
  ...defaultParagraphTheme,
  appearance: {
    ...defaultParagraphTheme.appearance,
    alt1: {
      ...defaultParagraphTheme.appearance.secondary,
      color: '#002EFF'
    }
  }
};
const floatingIconButtonTheme = {
  primaryColor: '#002EFF'
};
const redButtonTheme = {
  ...defaultButtonTheme,
  appearance: {
    ...defaultButtonTheme.appearance,
    primary: {
      ...defaultButtonTheme.appearance.primary
    },
    alt1: {
      ...defaultButtonTheme.appearance.alt1,
      color: '#FFFFFF',
      borderColor: '#FFFFFF',
      hover: {
        ...defaultButtonTheme.appearance.alt2.hover,
        borderColor: '#FFFFFF',
        color: '#FFFFFF'
      }
    },
    alt2: {
      ...defaultButtonTheme.appearance.alt2,
      color: '#FFFFFF',
      borderColor: '#FFFFFF',
      hover: {
        ...defaultButtonTheme.appearance.alt2.hover,
        borderColor: '#FFFFFF',
        color: '#FFFF'
      }
    }
  }
};
const redLinkWithIconTheme = {
  ...defaultLinkTheme,
  appearance: {
    ...defaultButtonTheme.appearance,
    primary: {
      ...defaultLinkTheme.appearance.primary,
      color: '#FFFFFF',
      hoverColor: '#FFFFFF'
    }
  }
};
const redHeadingTheme = {
  ...defaultHeadingTheme,
  appearance: {
    ...defaultHeadingTheme.appearance,
    primary: {
      ...defaultHeadingTheme.appearance.primary,
      color: '#FFFFFF'
    }
  }
};
const localThemes = {
  entel: {
    primaryColor: '#002EFF',
    fontFamily: 'Barlow',
    modalBody: {
      backgroundColor: '#ffffff',
      addPadding: true,
      maxHeight: false,
      contentWidth: {
        sm: '100%',
        lg: '100%'
      },
      footerWidth: '60%',
      smallFooterWidth: '70%'
    },
    header: {
      padding: 2,
      adustCloseBtn: true,
      marginBottom: '15px'
    },
    summary: {
      icon: {
        name: 'tick-circle',
        group: 'system'
      }
    },
    nextButton: {
      columns: 7
    },
    button: blueButtonTheme,
    linkWithIcon: linkWithIconTheme,
    rangeSlider: RangeSliderTheme,
    floatingIconButton: floatingIconButtonTheme,
    span: SpanTheme,
    heading: HeadingTheme,
    paragraph: ParagraphTheme,
    addButtonSpacing: true,
    pages: {
      COMPARISON: {
        addTableBorders: true,
        showComparisonProductTypeFullWidth: true,
        isUseComparisonBackButton: true,
        showHeaderTitle: false,
        specsHeadingWeight: 2,
        showPricePrefix: false,
        showColorToolTip: true,
        showDifferences: true,
        containerWithLabelStyle: {
          label: {
            bgColor: '#BEBEBE',
            color: '#000000',
            fontWeight: '400'
          },
          containerBorderStyle: '1px solid #BEBEBE'
        },
        applyThemeColorToTickIcon: true,
        comparisonCardsPadding: [0, 2],
        margin: {
          md: -20,
          lg: -30,
          sm: -13
        },
        withGridView: true,
        isBottomDiscount: true
      }
    },
    recommendation: {
      adjustPriceLayout: true,
      adjustProductInfo: true,
      adjustActionButton: true,
      showGreyBackground: false,
      showHeaderTitle: false,
      showNextButton: true,
      hideMatchValue: true,
      actionComponent: 'restart',
      containerWithLabelStyle: {
        bgColor: '#BEBEBE',
        color: '#000000',
        fontWeight: 'bold',
        borderColor: '#bebebe'
      },
      containerPaddingLevel: 0,
      spacingLevel: 0,
      footerWidth: '80%',
      collapsibleFeatureDescriptionSpacing: {
        sm: 20,
        md: 24,
        lg: 24,
        xl: 24
      },
      specsHeadingWeight: 2,
      disableTabsDropdown: true
    },
    showMainStepper: true,
    showProgressBar: false,
    showRecommendationStepper: true,
    imagePickerColumnsNumber: 3,
    imagePickerOrientation: 'vertical',
    varianceDropDownSpacing: 3,
    showRestartWarningMessage: true,
    recommendationPlanPadding: 0,
    recommendationPlanMargin: 0,
    fullScreenMobile: true,
    budgetQuestionBottomSpacing: 0,
    hasElevation: false
  },
  germany: {
    showRedBackGround: true,
    adjustButtons: true,
    showDivider: false,
    showWhiteBackGround: true,
    showProgressBar: false,
    primaryColor: '#FFFFFF',
    fontFamily: 'Barlow',
    modalBody: {
      modalBackgroundColor: '#820000',
      override: false,
      backgroundColor: '#470000',
      maxHeight: false,
      contentWidth: {
        sm: '100%',
        lg: '100%'
      },
      footerWidth: '68%',
      smallFooterWidth: '100%',
      smallScreenMargin: -24,
      largeScreenMargin: -40
    },
    header: {
      padding: 2,
      marginBottom: '15px'
    },
    nextButton: {
      columns: 1
    },
    button: redButtonTheme,
    linkWithIcon: redLinkWithIconTheme,
    heading: redHeadingTheme,
    addButtonSpacing: true,
    showRecommendationStepper: true,
    fullScreenMobile: true
  }
};
function getLocalTheme(localThemeName) {
  var _localThemes$localThe;
  return (_localThemes$localThe = localThemes[localThemeName]) !== null && _localThemes$localThe !== void 0 ? _localThemes$localThe : null;
}
const getLocalThemePrimaryColor = () => {
  var _themeWS10$color, _themeWS10$color$prim, _config$uiSettings;
  let primaryColor = _r10SourceLibrary.themeWS10 === null || _r10SourceLibrary.themeWS10 === void 0 ? void 0 : (_themeWS10$color = _r10SourceLibrary.themeWS10.color) === null || _themeWS10$color === void 0 ? void 0 : (_themeWS10$color$prim = _themeWS10$color.primary1) === null || _themeWS10$color$prim === void 0 ? void 0 : _themeWS10$color$prim.default;
  const ConfigThemeName = (_config$uiSettings = _config.default.uiSettings) === null || _config$uiSettings === void 0 ? void 0 : _config$uiSettings.theme;
  if (ConfigThemeName) {
    const overwrittenTheme = getLocalTheme(ConfigThemeName);
    if (overwrittenTheme) {
      primaryColor = overwrittenTheme.primaryColor;
    }
  }
  return primaryColor;
};
exports.getLocalThemePrimaryColor = getLocalThemePrimaryColor;